// this file is generated by update_shopify_store_data.py at 2026-06-22 20:35:25.860239
var courses = [
    {
        "course_id": "C7A4D921-60F4-EF11-9992-005056A7DAD4",
        "course_version": 3,
        "name": "Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
        "course_type": 1,
        "author_information": "Cathy Maxwell, PhD, RN, FAAN, FNAP",
        "description": "We are all aging however the pace and impact of our aging on our overall health depends on a myriad of factors, some within our control and others not. As healthcare professionals, these microlearnings offer you the opportunity to learn about the importance of mitochondria in the aging process and understand how development of a proactive aging plan can assist in maintaining mitochondrial fitness and promoting healthy aging. You can use this information to help yourself, your loved ones, and your patients.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<li>Describe how the role mitochondria play in our overall aging and health.\r\n</li>\r\n<li>Apply knowledge on tools and resources available to develop a healthy exercise plan for yourself and patients\r\n</li>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                "course_category_name": "Population Health Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Psychosocial Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nutrition",
                "is_system_course_category": null
            },
            {
                "course_category_id": "93FD0740-6FAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing: Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "00A65374-1B26-E711-9EDE-005056B14F90",
                "course_category_name": "Alternative Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                "course_category_name": "Geriatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Care Coordination",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E28C907C-6FAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Healthy Mitochondria, Healthy You: An Introduction to Cellular Wellness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A2B7FF67-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "End of Life Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 1 contact hour to participants who complete all sections and pass the assessment with a score of 90% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];